import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { FzhauptklasseListView } from './list-view/fzhauptklasse.list-view';

export const fzhauptklasseFieldOk: FieldOkConfig = {
  name: 'fzhauptklasse',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{fzhauptklasse}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzhauptklasseListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
export const fzhauptklasseMultiselectFieldOk: FieldOkConfig = {
  name: 'fzhauptklasse',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{fzhauptklasse}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzhauptklasseListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};

export const fzhauptklasseQueryFieldOk: FieldOkConfig = {
  name: 'fzhauptklasse',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{fzhauptklasse}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzhauptklasseListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
